// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"412":"474b6931","494":"29e51f3a","535":"cef0a19c","558":"50bc8905","827":"370657d2"}[chunkId] + ".css";
};